module.exports = "https://static.energy5.com/_next/static/images/eco-02112de3b99b066c498547ed5602cba9.png";